export default __webpack_public_path__ + "static/media/1117.abe13a5a.png";